import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { FalBalanceDTO } from '@amrita/shared';
import { TopBar } from '@/components/ui/TopBar';
import { Card } from '@/components/ui/Card';

export default function AdminFalBalancePage() {
  const { data, isLoading } = useQuery<FalBalanceDTO>({
    queryKey: ['fal-balance'],
    queryFn: () => api.get<FalBalanceDTO>('/api/admin/fal-balance'),
    refetchInterval: 60_000,
  });

  return (
    <div className="safe-bottom min-h-full">
      <TopBar title="FAL.ai баланс" />
      <div className="p-4 space-y-4">
        {isLoading && <div className="text-tg-hint">Загрузка…</div>}
        {data && (
          <>
            <Card className="text-center py-8">
              <div className="text-sm text-tg-hint">Текущий баланс</div>
              <div className={`text-4xl font-bold mt-2 ${data.thresholdBreached ? 'text-red-500' : 'text-brand-orange'}`}>
                ${data.balanceUsd.toFixed(2)}
              </div>
              <div className="text-xs text-tg-hint mt-2">
                Обновлено {new Date(data.asOf).toLocaleTimeString('ru-RU')}
              </div>
              {data.thresholdBreached && (
                <div className="mt-3 text-red-500 text-sm">
                  ⚠️ Ниже порога алерта ${data.threshold}
                </div>
              )}
            </Card>
            <Card>
              <div className="font-semibold mb-2">Траты</div>
              <div className="grid grid-cols-3 gap-2 text-sm">
                <div>
                  <div className="text-tg-hint">Сегодня</div>
                  <div className="font-medium">${data.spent.today.toFixed(2)}</div>
                </div>
                <div>
                  <div className="text-tg-hint">Неделя</div>
                  <div className="font-medium">${data.spent.week.toFixed(2)}</div>
                </div>
                <div>
                  <div className="text-tg-hint">Месяц</div>
                  <div className="font-medium">${data.spent.month.toFixed(2)}</div>
                </div>
              </div>
            </Card>
          </>
        )}
      </div>
    </div>
  );
}
